import React, {useEffect, useState} from "react";
import {db, storage} from "../firebase_setup/firebase"
import {getDownloadURL, listAll, list, ref} from "firebase/storage";
import {collection, getDocs} from "firebase/firestore";
import Carousel from 'react-gallery-carousel';
import 'react-gallery-carousel/dist/index.css';
import './PhotoGallery.css'
function PhotoGallery() {
    const [imgArray,setImgArray] = useState<{ src: string }[]>([]);
    const [imagesDownloaded, setImagesDownloaded] = useState(false);

    useEffect(() => {
        let ignore = false;
        const fetchData = async ()  => {
            let foldersToPull: string[] = [];
            const subCollection = collection(db,'Festivals');
            if (!ignore) {
                const querySnapshot = await getDocs(subCollection);
                querySnapshot.forEach((doc) => {
                    if (doc.data()['active']) {
                        foldersToPull.push(doc.id);
                    }
                });
            }
            return foldersToPull;
        }

        const pullImages = (foldersToPull: string[]) => {
            const storageRef = ref(storage, 'images/');
            if (!ignore) {
                list(storageRef).then((res) => {
                    res.prefixes.forEach((folderRef) => {
                        if (foldersToPull.includes(folderRef.name)) {
                            listAll(folderRef).then((res) => {
                                res.items.forEach((itemRef) => {
                                    getDownloadURL(itemRef).then((url) => {
                                        setImgArray(imgArray => [...imgArray, {src: url}]);
                                    })
                                })
                            }).catch((error) => console.log(error));
                        }
                    })
                }).then(() => {
                    setImagesDownloaded(true);
                })
            }
        }

        if (!ignore) {
            fetchData().then((foldersToPull) => pullImages(foldersToPull))
        }

        return () => {
            ignore = true;
        }
    },[]);

    return (
        <div>
            {imagesDownloaded? (
                <div className={"centered-div"}>
                    <Carousel images={imgArray}
                               isAutoPlaying={true}
                               className={"carousel"}/>

                </div>
            ) : (
                <div>
                    Loading Images
                </div>
            )}

        </div>
    )

}

export default PhotoGallery;